import { PageLayout } from '~/components/PageLayout/PageLayout';
import { withAuthentication } from '~/hocs/withAuthentication';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';

const List = withAuthentication(({ user }) => {
  if (user.permissions.federation_admin) {
    return (
      <Fragment>
        <p>Genom att du är förbundsadministratör så har du rättigheter till alla tävlingar.</p>
        <p>
          Därför bör du istället använda dig utav <Link to="/competitions">tävlingskatalogen</Link>, som du även kommer
          åt via huvudmenyn.
        </p>
      </Fragment>
    );
  }

  const competitions = user.permissions.competitions_admin.sort((a, b) => a.name.localeCompare(b.name));

  if (!competitions.length) {
    return <p>Du har inga tävlingar som du administrerar för tillfället.</p>;
  }

  return (
    <Table bg="even">
      <Table.Head>
        <Table.Row>
          <Table.Col as="th">Tävling</Table.Col>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {competitions.map(competition => (
          <Table.Row key={competition.id}>
            <Table.Col>
              <Link to={`/competitions/${competition.id}`}>{competition.name}</Link>
            </Table.Col>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
});

export function Page() {
  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Mina tävlingar" />
      </PageLayout.Header>

      <List />
    </Fragment>
  );
}
